import { Config } from '../../config'

export const blueridgeConfig: Config = {
  partner: 'blueridge',
  catalog: 'partner',
  displayName: 'Blue Ridge Ergonomics',
  accentColor: '#156fb4',
  host: 'seating.blueridgeergonomics.com',
  extraAttributes: {
  }
}
